// write constants here

export const SESSION_EXPIRY = "Session Expired!";
export const INTERNAL_ERROR = "Internal server error, Please contact admin!";
export const SERVER_ERROR = "Server can't be reached!";
export const UNAUTHORIZED_MESSAGE = "Unauthorized!";
export const NOT_FOUND_MESSAGE = "Not found!";
export const USER_NOT_FOUND = "User not found!";
export const SESSION_TOKEN = "session-token";
export const SOCKET_EVENTS = {
  CONNECTION: "connection",
  DISCONNECT: "disconnect",
  SEND_MESSAGE: "sendMessage",
  RECEIVE_MESSAGE: "receiveMessage",
  OPERATOR_MESSAGES: "operatorMessages",
  SEND_OPERATOR_MESSAGE: "sendOperatorMessage",
  AGENT_CONNECTION: "agentConnection",
  AGENT_TYPING: "agentTyping",
  CUSTOMER_DISCONNECT: "customerDisconnect",
  CONNECT_ERROR: "connect_error",
  INITIATE_GOOGLE_ASSISTANT: "initiate_google_assistant"
};

export const TermsConditions = {
  heading:
    "CONCLUSION OF HOME INSURANCE CONTRACT AND STANDARD CONDITIONS OF CONTRACT ",
  para1:
    "Insurer shall issue an insurance policy, on the basis of the data gathered from Policyholder. Insurance contract shall be considered as concluded if Policyholder pays the insurance premium in time. Insurance cover is effective from the beginning of insurance period under the conditions mentioned in the insurance policy, even if the insurance premium has not been paid yet because of a later deadline.",
  para2:
    "If Policyholder fails to pay the premium, it is assumed that s/he did not wish to conclude the contract under the policy conditions and the contract has not been concluded. In this case there is no insurance cover.",
  para3:
    "Please read your policy details to make sure you understand what is covered and the limits that apply. It’s important that you check the information that you have given us to ensure we offer you the correct cover. You must let us know promptly if there are any changes required. If we are not informed of any changes a claim may be reduced or rejected and in some circumstances your policy might be invalid.",
};

export default {
  paymentHeading: "Choose a payment method",
  waPaymentHeading: "Confirm Payment",
  paymentSubHeading:
    "The merchant uses their payment gateway APIs to manage recurring billing.",
  // waPaymentSubHeading:
  //   "On clicking pay now you will be redirected to payment gateway",
  paymentSuccess: "Your payment is successful.",
  paymentFailed: "Your payment is failed.",

  paymentSuccessSubText:
    " The merchant uses their payment gateway APIs to The merchant uses their payment gateway A The merchant uses their payment gateway A The merchant uses their payment gateway A ",
  cardNumber: "Card Number",
  cardNumberErrorMsg: "Please enter valid card number",
  nameOnCardErrorMsg: "Please enter valid name on card",
  nameOnCard: "Name on Card",
  expiry: "mm/yy",
  expiryErrorMsg: "Please enter valid expiry",
  CVV: "CVV",
  cvvErrorMsg: "Please enter valid cvv",
  debitCreditCard: "Debit/Credit Card",
  internetBanking: "Internet Banking",
  payNowBtn: "Pay Now",
  makePaymentBtn: "Make Payment",
  submit: "Submit",
  otpSubText:
    "Please enter the 6-digit verification code sent to your mobile number and click submit.",
  otpHeading: "Two-factor Authentication",
  finalSuccessMessage:
    "Your payment is successful and the new itinerary has been sent to the registered email address.",
};

export const TYPE_PLACEHOLDER = "Type a message...";

export const QUICK_SUGGESTIONS = {
  PAYMENT_FAILED:
    "Thank you for reaching out. Kindly recheck your credit card details. i.e. the card number, expiry date and CVV number. Once you have the details handy, then please click on the link below to access the payment gateway: https://payment.gateway.com.",
  EXISTING_POLICY:
    "Please provide your existing Policy number, Name, Date of birth and Post code number.",
  QUOTE_REJECT:
    "Thank you for reaching out and providing the responses to the questions raised. Below are some options through which your quote can be revised. Either you can opt to increase your voluntary excess/deductible contribution per claim or review you re-build cost.",
};
